module.exports = __webpack_public_path__ + "static/media/project3.05e02eb5.png";